import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, SparklesIcon } from 'lucide-react';
import { proofPoints, ProofPoint } from '../data/content';
function Card({
  point
}: {
  point: ProofPoint;
}) {
  return <article className="flex h-full flex-col rounded-2xl border border-primary/15 bg-card p-6 shadow-sm shadow-foreground/5" data-id="element-177" data-mp="350n9wnuahcp6">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-highlight/25 text-foreground" data-id="element-178" data-mp="39yyiywcrfj6c">
        <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-179" data-mp="3e0a8l1vmw4ej" />
      </span>
      <h3 className="mt-4 font-display text-lg font-bold leading-snug text-foreground" data-id="element-180" data-mp="3is1pslswgxs0">
        {point.title}
      </h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground/75" data-id="element-181" data-mp="3nq3b7ddst96n">{point.description}</p>
    </article>;
}
export function ProofSection() {
  const [index, setIndex] = useState(0);
  const go = useCallback((dir: number) => {
    setIndex(prev => (prev + dir + proofPoints.length) % proofPoints.length);
  }, []);
  return <section className="w-full bg-card px-5 py-12 sm:py-20" data-id="element-182" data-mp="15l5egwybdj2t">
      <div className="mx-auto max-w-5xl" data-id="element-183" data-mp="10mu1wegmwugw">
        <div className="mx-auto max-w-2xl text-center" data-id="element-184" data-mp="vpc49k82i1o7">
          <h2 className="font-display text-2xl font-bold leading-tight text-foreground sm:text-4xl" data-id="element-185" data-mp="vpu74zp8je53">
            Dlaczego z tego naprawdę się korzysta
          </h2>
          <p className="mt-3 text-sm text-foreground/70 sm:text-base" data-id="element-186" data-mp="1oej2sj7iur9g">
            Stworzone z myślą o tym, jak wygląda majsterkowanie przy kuchennym stole.
          </p>
        </div>

        <div className="mt-10 hidden gap-6 md:grid md:grid-cols-3" data-id="element-187" data-mp="1eny6j2fblytp">
          {proofPoints.map(point => <Card key={point.title} point={point} data-id="element-188" data-mp="1an4hu6u20fzr" />)}
        </div>

        <div className="mt-10 md:hidden" data-id="element-189" data-mp="274h7qqg0w48v">
          <div className="relative overflow-hidden" data-id="element-190" data-mp="275ahm0aa39v8">
            <AnimatePresence mode="wait" data-id="element-191" data-mp="22dsi7gnwlhcd">
              <motion.div key={index} initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -40
            }} transition={{
              duration: 0.3,
              ease: 'easeOut'
            }} data-id="element-192" data-mp="22cpnsyrdgwrp">
                <Card point={proofPoints[index]} data-id="element-193" data-mp="3mwcqyvqj7cj8" />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="mt-5 flex items-center justify-between" data-id="element-194" data-mp="3rtus3zyb4ngo">
            <button type="button" onClick={() => go(-1)} aria-label="Previous point" className="flex h-11 w-11 items-center justify-center rounded-full border border-primary/30 text-primary-strong transition-colors hover:bg-secondary" data-id="element-195" data-mp="3dvemydg3f50n">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-196" data-mp="38vig86g0gzhe" />
            </button>

            <div className="flex gap-2" data-id="element-197" data-mp="125u4lfj1ox7c">
              {proofPoints.map((point, i) => <button key={point.title} type="button" onClick={() => setIndex(i)} aria-label={`Go to point ${i + 1}`} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? 'w-6 bg-primary' : 'w-2 bg-primary/25'}`} data-id="element-198" data-mp="174f3nbmk9au7" data-mpi={i} />)}
            </div>

            <button type="button" onClick={() => go(1)} aria-label="Next point" className="flex h-11 w-11 items-center justify-center rounded-full border border-primary/30 text-primary-strong transition-colors hover:bg-secondary" data-id="element-199" data-mp="2wl0y7je01jg8">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-200" data-mp="3kav6roracluo" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}